import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { RouterModule } from '@angular/router';
import { TranslateModule } from '@ngx-translate/core';

import { ModuleIconComponent } from 'presentation/app-sidebar/sidebar-coaching-plan/plan-phase/phase-section/section-module/section-module-icon/module-icon.component';

import { AppPrimengModule } from '../../../../../app-primeng.module';
import { AppSharedModule } from '../../../../../app-shared.module';
import { PhaseSectionComponent } from './phase-section.component';
import { SectionEditModuleComponent } from './section-module/section-module-edit/section-edit-module.component';
import { SectionInfoComponent } from './section-module/section-module-info/section-info.component';
import { SectionModuleComponent } from './section-module/section-module.component';
import { SectionProgressComponent } from './section-progress/section-progress.component';
import { SectionTitleComponent } from './section-title/section-title.component';

@NgModule({
	declarations: [
		ModuleIconComponent,
		PhaseSectionComponent,
		SectionModuleComponent,
		SectionProgressComponent,
		SectionInfoComponent,
		SectionEditModuleComponent,
		SectionTitleComponent,
	],
	imports: [
		FormsModule,
		CommonModule,
		RouterModule,
		AppPrimengModule,
		ReactiveFormsModule,
		TranslateModule.forChild(),
		AppSharedModule,
	],
	exports: [
		ModuleIconComponent,
		PhaseSectionComponent,
		SectionModuleComponent,
		SectionProgressComponent,
		SectionInfoComponent,
	],
	providers: [],
})
export class PhaseSectionModule {}
